import { EMPTY_STRING } from '../../../../../../../NonReact/constants/Common'
import { DASH } from '../../../../../Constants/Separators'

const ZERO: string = '0'

/**
 * Count the number of leading zeros in a string.
 *
 * @param input - The input string to count leading zeros in.
 */
export const countLeadingZeros = (input: string): number =>
    input.split(EMPTY_STRING).reduce(
        (
            count: { total: number; continueCounting: boolean },
            char: string
        ): {
            total: number
            continueCounting: boolean
        } =>
            count.continueCounting && char === '0'
                ? { total: count.total + 1, continueCounting: true }
                : { total: count.total, continueCounting: false },
        { total: 0, continueCounting: true }
    ).total

/**
 * Process the new display value based on the old display value and the new numeric value.
 * This function replaces the numeric characters in the old display value with the new numeric value.
 *
 * @param oldDisplayValue - The old display value.
 * @param newNumericValue - The new numeric value.
 */
export const processDisplayValue = (oldDisplayValue: string, newNumericValue: number): string => {
    // Get a template of the old display value.
    const oldDisplayValueTemplate: string = oldDisplayValue.replace(/\d/g, ZERO)
    const newValueAsStringArr: string[] = newNumericValue.toString().split(EMPTY_STRING).reverse()

    // Find the number of leading zeros in the old display value.
    const leadingZeroCount: number = countLeadingZeros(oldDisplayValue)

    return (
        oldDisplayValueTemplate
            .split(EMPTY_STRING)
            .map((char: string, index: number): Definable<string> => {
                if (char === ZERO && index >= leadingZeroCount) {
                    return newValueAsStringArr.pop()
                }

                return char
            })
            .join(EMPTY_STRING) + newValueAsStringArr.join()
    )
}

export const normaliseDashes = (s: string): string => (s ?? EMPTY_STRING).replace(/[‐-‒–—−]/g, DASH)
